import { ConsultationCard, Consultation } from 'types';

export const isOverdue = (
  consultation: Consultation | ConsultationCard | undefined
): boolean =>
  consultation?.status === 'Overdue' ||
  (!consultation?.isArchived &&
    !!consultation?.deadlineDate &&
    new Date(consultation.deadlineDate).setHours(0, 0, 0, 0) <
      new Date().setHours(0, 0, 0, 0));
